import { useCallback, useMemo } from 'react';
import type { DropdownItemEntry, ManageSimItemHook } from '../types';

const useManageTags: ManageSimItemHook = ({
  context,
  selectedSims,
  handleModalOpen,
  onActionTaken,
  onSimsModified,
  disabled,
}) => {
  const onClick = useCallback(() => {
    handleModalOpen({
      modalName: 'TagManagerModal',
      modalProps: { sims: selectedSims, onModalSuccess: onSimsModified },
    });
    onActionTaken();
  }, [onActionTaken, handleModalOpen, onSimsModified, selectedSims]);

  const show = context === 'inventory';

  return useMemo<DropdownItemEntry | false>(
    () =>
      show && {
        children: 'Manage tags...',
        iconStart: 'Tag',
        disabled,
        onClick,
        limit: 10000,
        id: `sim${context}-manage-tags`,
      },
    [context, disabled, onClick, show]
  );
};

export default useManageTags;
